import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { pdfColors, pdfFontSize, pdfLetter, pdfSpacing } from '../theme';

interface Props {
  /** One caption per signature slot, left to right. */
  slots: string[];
  /** Vertical room above each line for the actual signature (pt). */
  inkSpace?: number;
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    marginHorizontal: -pdfSpacing.md,
  },
  slot: {
    flex: 1,
    paddingHorizontal: pdfSpacing.md,
  },
  line: {
    borderTopWidth: 0.7,
    borderTopColor: pdfColors.textPrimary,
    borderTopStyle: 'solid',
    marginBottom: 4,
  },
  caption: {
    fontSize: pdfFontSize.xxs,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: pdfLetter.openLabel,
    color: pdfColors.textMuted,
  },
});

/** Evenly spaced signature lines with captions. Never splits across pages. */
const Signatures: React.FC<Props> = ({ slots, inkSpace = 30 }) => (
  <View style={styles.row} wrap={false}>
    {slots.map((caption) => (
      <View key={caption} style={styles.slot}>
        <View style={[styles.line, { marginTop: inkSpace }]} />
        <Text style={styles.caption}>{caption}</Text>
      </View>
    ))}
  </View>
);

export default Signatures;
